import { render, staticRenderFns } from "./PetAndProjectBreadcrumbsComponent.vue?vue&type=template&id=143a4002&scoped=true&"
import script from "./PetAndProjectBreadcrumbsComponent.vue?vue&type=script&lang=js&"
export * from "./PetAndProjectBreadcrumbsComponent.vue?vue&type=script&lang=js&"
import style0 from "./PetAndProjectBreadcrumbsComponent.vue?vue&type=style&index=0&id=143a4002&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143a4002",
  null
  
)

export default component.exports